/**
 * guide/report 변경 신고 island.
 *
 * Mount: `<form data-mount="report" data-service-slug="..." data-guide-slug="...">`
 *   `<textarea required minlength="10" maxlength="1000">`
 *   `<button type="submit">`
 *   Optional: `<div data-report-status>` for status text.
 */

import { getOrCreateAnonId } from "./anonymous-id";

type Bound = { serviceSlug: string; guideSlug: string; root: HTMLElement };

function readBinding(el: HTMLElement): Bound | null {
  const serviceSlug = el.dataset.serviceSlug;
  const guideSlug = el.dataset.guideSlug;
  if (!serviceSlug || !guideSlug) return null;
  return { serviceSlug, guideSlug, root: el };
}

function setStatus(root: HTMLElement, text: string): void {
  const target = root.querySelector<HTMLElement>("[data-report-status]");
  if (target) target.textContent = text;
}

export function mountReport(root: HTMLElement): void {
  const bound = readBinding(root);
  if (!bound) return;
  const form = root instanceof HTMLFormElement ? root : root.querySelector("form");
  if (!form) return;

  form.addEventListener("submit", async (ev) => {
    ev.preventDefault();
    const textarea = form.querySelector<HTMLTextAreaElement>("textarea");
    const description = textarea?.value.trim() ?? "";
    if (description.length < 10 || description.length > 1000) {
      setStatus(bound.root, "10~1000자로 입력해주세요");
      return;
    }
    const submit = form.querySelector<HTMLButtonElement>("button[type='submit']");
    if (submit) submit.disabled = true;
    try {
      const res = await fetch("/api/reports", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          anon_id: getOrCreateAnonId(),
          service_slug: bound.serviceSlug,
          guide_slug: bound.guideSlug,
          description,
        }),
      });
      if (res.status === 429) {
        setStatus(bound.root, "이미 신고하셨습니다 (1시간 후 다시)");
        return;
      }
      if (!res.ok) {
        setStatus(bound.root, "잠시 후 다시 시도해주세요");
        if (submit) submit.disabled = false;
        return;
      }
      setStatus(bound.root, "신고 접수됨, 24시간 내 확인 ✓");
      if (textarea) textarea.value = "";
    } catch {
      setStatus(bound.root, "잠시 후 다시 시도해주세요");
      if (submit) submit.disabled = false;
    }
  });
}
